import React from 'react'
import './index.css'

import IconTrashCan from '../icons/IconTrashCan'

const PartNameDeletable = ({ row, onClick, disabled, part }) => {


  const text = [ row.partnum ]

  return (
    <span className="bin-name-deletable">
      <span className="bin-name-deletable__bin-name">{text}</span>

    </span>
  )
}

export default PartNameDeletable
